<template>
  <md-card class="md-card-login" :class="{'md-card-hidden': cardHidden}">
    <div class="loader_container">
      <slot name="loader"></slot>
    </div>

    <md-card-media>
      <img class="md-alignment-center" src="https://res.cloudinary.com/pixel-bucket/image/upload/v1577030508/etax/lris_lhd8ny.gif" alt="logo">
      <!--TODO - Make this is slot too-->
      <!--<slot name="logo"></slot>-->
    </md-card-media>

    <!--<md-card-header :class="getClass(headerColor)">-->
    <!--<slot name="title"></slot>-->
    <!--<div class="social-line">-->
    <!--<slot name="buttons"></slot>-->
    <!--</div>-->
    <!--</md-card-header>-->
    <md-card-content>
      <slot name="inputs"></slot>
    </md-card-content>

    <md-card-actions>
      <slot name="footer"></slot>
    </md-card-actions>

    <md-card-actions>
      <slot name="footer2"></slot>
    </md-card-actions>

    <md-card-content class="tabs-slot">
      <div class="tabs">
        <a href="javascript:void(0)" class="tablink" :class="payerLogin.class" @click.prevent="openLoginPage(payerLogin)">
          <i class="fa fa-user"></i> Payer
        </a>

        <a href="javascript:void(0)" class="tablink" :class="consultantLogin.class" @click.prevent="openLoginPage(consultantLogin)">
          <i class="fa fa-user-circle"></i> Consultant
        </a>

        <a href="javascript:void(0)" class="tablink last" :class="adminLogin.class" @click.prevent="openLoginPage(adminLogin)">
          <i class="fa fa-user-circle"></i> Admin
        </a>
      </div>
    </md-card-content>
    <md-card-content class="verify-tcc">
      <p @click="$router.push({ name: 'tccverification' })">Verify a Tax Clearance Certificate</p>
    </md-card-content>
    <md-card-content class="browser-comp">
      <md-field>
        <p class="browser-comp-text">
          To get the most out of using eTax, please login with a supported browser: Chrome, Firefox, Safari
        </p>
      </md-field>
    </md-card-content>
  </md-card>
</template>

<script>
export default {
  name: "login-card",

  props: {
    headerColor: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      cardHidden: true,
      payerLogin: {
        name: this.$constants.login.payer,
        path: "/login",
        class: ""
      },
      adminLogin: {
        name: this.$constants.login.admin,
        path: "/admin/login",
        class: ""
      },
      consultantLogin: {
        name: this.$constants.login.consultant,
        path: "/consultant/login",
        class: ""
      }
    };
  },

  beforeMount() {
    setTimeout(this.showCard, 400);
  },

  methods: {
    showCard: function() {
      this.cardHidden = false;
    },

    getClass: function(headerColor) {
      return "md-card-header-" + headerColor + "";
    },

    openLoginPage(loginType) {
      if(loginType.class === "active") { return; }
      this.$router.push(loginType.path);
    }
  },

  mounted() {
    const routeName = this.$route.name;

    switch (routeName) {
      case this.adminLogin.name:
        this.adminLogin.class = "active";
        break;
      case this.consultantLogin.name:
        this.consultantLogin.class = "active";
        break;
      default:
        this.payerLogin.class = "active";
    }
  }
};
</script>

<style lang="css" scoped>
.md-card-media {
  width: 45%;
  margin: -105px auto 0 auto;
}
.loader_container {
  height: 40px;
}
.browser-comp {
  text-align: center;
  font-size: small;
  background-color: #d95260;
  padding-bottom: 0px;
}
.tabs-slot{
  padding: 0px;
}

.tabs {
  float: left;
  width: 100%;
}
.tablink {
  background-color: #dcdcdc;
  color: #696969 !important;
  float: left;
  border: none;
  outline: none;
  cursor: pointer;
  padding: 10px;
  font-size: 15px;
  width: 33%;
  border-right: 1px solid #ffffff;
  font-weight: 400;
}
.tablink.last {
  width: 34%;
  border: none;
}
.tablink:hover {
  background: #ffffff;
  color: #4caf50 !important;
}
.tablink.active {
  background: #ffffff;
  color: #4caf50 !important;
  cursor: default;
}
p {
  color: #ffffff;
  font-weight: 600;
}

.verify-tcc {
  background: #e9ffea;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px 20px;
}

.verify-tcc p {
  color: #4caf50;
  line-height: 1.6;
  font-size: 12px;
  margin: 0;
  text-decoration: underline;
  cursor: pointer;
}

.browser-comp .md-field{
  padding-top: 0px;
  padding-bottom: 0px;
  margin-top: 0px;
  margin-bottom: 0px;
}
.browser-comp .md-field::after{
  display: none;
}

@media (max-width: 480px), (max-width: 640px){
  .tablink {
    font-size: 14px;
  }
}
</style>

<!-- <div class="card card-login card-hidden">
  <div class="card-header card-header-rose text-center">
    <h4 class="card-title">Log in</h4>
    <div class="social-line">
      <a href="#pablo" class="btn btn-just-icon btn-link btn-white">
        <i class="fa fa-facebook-square"></i>
      </a>
      <a href="#pablo" class="btn btn-just-icon btn-link btn-white">
        <i class="fa fa-twitter"></i>
      </a>
      <a href="#pablo" class="btn btn-just-icon btn-link btn-white">
        <i class="fa fa-google-plus"></i>
      </a>
    </div>
  </div>
  <div class="card-body ">
    <p class="card-description text-center">Or Be Classical</p>
    <span class="bmd-form-group">
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text">
            <i class="material-icons">face</i>
          </span>
        </div>
        <input type="text" class="form-control" placeholder="First Name...">
      </div>
    </span>
    <span class="bmd-form-group">
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text">
            <i class="material-icons">email</i>
          </span>
        </div>
        <input type="email" class="form-control" placeholder="Email...">
      </div>
    </span>
    <span class="bmd-form-group">
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text">
            <i class="material-icons">lock_outline</i>
          </span>
        </div>
        <input type="password" class="form-control" placeholder="Password...">
      </div>
    </span>
  </div>
  <div class="card-footer justify-content-center">
    <a href="#pablo" class="btn btn-rose btn-link btn-lg">Lets Go</a>
  </div>
</div> -->
